import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Phone, EnvelopeSimple, MapPin, Clock } from "@phosphor-icons/react";
import { LOGO_IMG } from "@/lib/brand";

export function Footer() {
  const [s, setS] = useState(null);
  useEffect(() => {
    api.get("/settings").then(({ data }) => setS(data)).catch(() => {});
  }, []);
  if (!s || !s.company_name) return null;
  return (
    <footer className="border-t border-slate-200 bg-navy-900 text-slate-300 mt-24" data-testid="global-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid md:grid-cols-3 gap-12">
        <div>
          <img src={LOGO_IMG} alt="PMI" className="h-14 w-auto bg-white rounded-md p-1.5 mb-4" />
          <h3 className="font-display text-2xl text-white tracking-tight">{s.company_name}</h3>
          <p className="mt-3 text-sm leading-relaxed text-slate-400 max-w-xs">{s.tagline}</p>
          <div className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-amber-500 font-bold">
            9×12 Virtual Postcard Network
          </div>
        </div>
        <div className="space-y-3 text-sm">
          <p className="uppercase tracking-[0.2em] text-xs font-bold text-slate-500 mb-4">Contact</p>
          <p className="flex items-center gap-3"><Phone size={16} className="text-amber-500" /> {s.phone}</p>
          <p className="flex items-center gap-3"><EnvelopeSimple size={16} className="text-amber-500" /> {s.email}</p>
          <p className="flex items-start gap-3"><MapPin size={16} className="text-amber-500 mt-0.5" /> {s.address}</p>
          <p className="flex items-center gap-3"><Clock size={16} className="text-amber-500" /> {s.support_hours}</p>
        </div>
        <div className="space-y-3 text-sm">
          <p className="uppercase tracking-[0.2em] text-xs font-bold text-slate-500 mb-4">Access</p>
          <a href="/partner" className="block hover:text-amber-500 transition-colors" data-testid="footer-partner-link">Become a Partner</a>
          <a href="/login" className="block hover:text-amber-500 transition-colors" data-testid="footer-login-link">Portal Login</a>
          <a href="/admin" className="block hover:text-amber-500 transition-colors" data-testid="footer-admin-link">Admin Console</a>
        </div>
      </div>
      <div className="border-t border-navy-800 py-6 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} {s.company_name}. All rights reserved.
      </div>
    </footer>
  );
}
